import { render, staticRenderFns } from "./QuickNavigation.vue?vue&type=template&id=68c50bb0&scoped=true"
import script from "./QuickNavigation.vue?vue&type=script&lang=js"
export * from "./QuickNavigation.vue?vue&type=script&lang=js"
import style0 from "./QuickNavigation.vue?vue&type=style&index=0&id=68c50bb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c50bb0",
  null
  
)

export default component.exports